// Copyright (c) 2017 Deere & Company

import RecordAudit from '../../tcsm/record-audit/components';

export default {
    component: RecordAudit,
    name: 'RECORD_AUDIT',
    path: 'audits/record'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/record-audit.js